import { HexDistanceInfo } from "@/core/battle/ai/types/ai.types";
import { CombatCalculator } from "@/core/battle/CombatCalculator";
import ManagerRegistry from "@/core/battle/ManagerRegistry";
import { PathCalculator } from "@/core/battle/PathCalculator";
import { BattleUnit, Hex } from "@/core/types/battle.types";
import { coordsToId, getHexDistance, idToCoords } from "@/core/utils/hex.utils";

const AVERAGE_INTERRUPT_CHANCE = 0.75;

export class DistanceMatrixCalculator {

    public static calculate(
        hexId: string,
        enemies: BattleUnit[],
    ): HexDistanceInfo {
        const registry = ManagerRegistry.getInstance().entityRegistry;

        const hex: { q: number; r: number; } = registry.getHex(hexId)?.data ?? idToCoords(hexId);
        const distances = new Map<string, number>();
        let minDist = Infinity;
        let closestEnemyId: string | null = null;
        
        for (const enemy of enemies) {
            const dist = getHexDistance(hex, enemy);
            distances.set(enemy.unitId, dist);
            
            if (dist < minDist) {
                minDist = dist;
                closestEnemyId = enemy.unitId;
            }
        }

        return { distances, minDist, closestEnemyId };
    }
}